import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';

// Components
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import ContactarCard from "../../molecules/contactar-card/contactarCard";
import { Toast } from "../../ui/toast/Toast";

//Styles
import "./FormContactar.scss";

const FormContactar = (props: any) =>{

    const data = useStaticQuery(graphql`
        query contentfulFormContactar {
            formIndividual: allContentfulContactenos(
                filter: { contentful_id: { eq: "2s6gLmYXXLFwnLUHe5Q0nB" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    metaTitulo
                    titulosFormulario {
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            placeholder
                            obligatorio
                            seccion
                            tabOrder
                            ayuda
                        }
                        tituloBoton
                    }
                }
            }
            formGrupal: allContentfulContactenos(
                filter: { contentful_id: { eq: "1P0weYCsTITELDwvwW1xtc" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    metaTitulo
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            placeholder
                            obligatorio
                            seccion
                            tabOrder
                            ayuda
                        }
                        tituloBoton
                    }
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "1fDSdtSYmSktYARBLyuhCC" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    tituloFormulario
                    descripcionFormulario {
                        raw
                    }
                    imagenesEmpleo {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                }
            }
            modalCancelar: allContentfulContactenos(
                filter: { contentful_id: { eq: "7rlfFvhltfdKtSjRjArvIo" } }
            ) {
                nodes {
                    tituloPrincipal
                    tituloBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                }
            }
            removeTalent: allContentfulPlantillaContenido(filter: {contentful_id: {eq: "78GfQfH8GqVRRVMRw33iZ4"}}
                ) {
                    edges {
                        node {
                            tituloBanner
                            tituloBoton
                        }
                    }
                }
            selectTalent: allContentfulPlantillaContenido(filter: {contentful_id: {eq: "1Q4NKCusHkBiiIRbRJgYTX"}}
                ) {
                edges {
                    node {
                        tituloBanner
                        tituloBoton
                    }
                }
            }
            modalFailure: allContentfulContactenos(
                filter: { contentful_id: { eq: "5p2JLSclPHVNCgJpKw3jUK" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    descripcionFormulario {
                        raw
                    }
                    imagenFormulario {
                        file {
                            details {
                                image {
                                    width
                                    height
                                }
                            }
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                }
            }
        }
    `);

    const { isBrowser, window } = useBrowserMode();
    const [pathname, setPathname] = useState("");
    const [talentName, setTalentName] = useState("");
    const locStorage = localStorage.getItem('talentsSelected');
    const selectedTalents = JSON.parse(locStorage!!);
    const [listSelectedTalents, setListSelectedTalents] = useState(selectedTalents);
    const [isIndividual, setIsIndividual] = useState<boolean>(true);
   
    useEffect(() => {
        const getData = () => {
            if(isBrowser) {
                if (window.location.pathname.includes("empresas")) {
                    setPathname("Empresas")
                }
                if (window.location.pathname.includes("grupal")) {
                    setIsIndividual(false)
                }else{
                    setTalentName(nameAndLastNameFixed(listSelectedTalents[0].nombres, listSelectedTalents[0].apellidos))
                }
            }
        };
        getData()
    }, []);

    const formData = isIndividual ? data.formIndividual.nodes[0] : data.formGrupal.nodes[0];
    const modalSuccess  = data.modalSuccess.nodes[0];
    const modalCancelar = data.modalCancelar.nodes[0];
    const breadCrumbMessage = isIndividual 
                            ? `Inicio / ${pathname} / Encontrar Talento / ${formData.tituloPrincipal} ${talentName}`
                            : `Inicio / ${pathname} / Encontrar Talento`;      
    const messageTalent = [data.removeTalent.edges[0].node, data.selectTalent.edges[0].node];
    const modalFailure  = data.modalFailure.nodes[0];
    const [activateToast, setActivateToast] = useState<boolean>(false);
    if (selectedTalents) {
        localStorage.removeItem('talentsSelected');
    }

    const nameAndLastNameFixed = (nombres, apellidos) => {
        
        const name = nombres.toLowerCase().split(' ');
        const nameFixed = name.map(name => name.charAt(0).toUpperCase() + name.slice(1));

        const lastName = apellidos.toLowerCase().split(' ');
        const lastNameFixed = lastName.map(lastName => lastName.charAt(0).toUpperCase() + lastName.slice(1));

        return nameFixed.join(" ") + " " + lastNameFixed.join(" ");
    }

    return (
        <div className={`m-form-contactar ${!isIndividual ? "grupal" : ""}`}>
            <div className="m-breadcrumb">
                <Breadcrumb content={breadCrumbMessage}/>
            </div>
            <ContactarCard
                tituloPrincipal={formData.tituloPrincipal}
                descripcionFormulario={
                    JSON.parse(formData.descripcionFormulario.raw)
                }
                titulosFormulario={formData.titulosFormulario}
                modalSuccess={modalSuccess}
                talentName = {talentName}
                modalCancelar={modalCancelar}
                listSelectedTalents={listSelectedTalents}
                isIndividual={isIndividual}
                setListSelectedTalents={setListSelectedTalents}
                messageTalent={messageTalent}
                modalFailure={modalFailure}
                setActivateToast={setActivateToast}
            />
            {activateToast && <Toast text={`&#10004; Talento Eliminado`} />}
        </div>
    );
};

export default FormContactar;